import React from 'react'

import { AllCodingRoomsData } from '../codingRooms.types'

import CodingRoomCard from './CodingRoomCard'

const CodingRoomsGrid = ({ rooms }: { rooms: AllCodingRoomsData }) => {
  if (
    !rooms ||
    !rooms.active_user_room ||
    !rooms.user_coding_room ||
    !rooms.coding_rooms
  ) {
    return (
      <p className="text-center text-xl text-zinc-400">No Active Rooms Found</p>
    )
  }

  return (
    <div className="flex flex-col justify-center items-center gap-y-4">
      {rooms.active_user_room.length > 0 && (
        <div className="flex flex-col gap-2 items-center">
          <div className="text-center font-semibold text-lg">
            Your Active Rooms
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-8">
            {rooms.active_user_room.map((room) => (
              <div className="w-[22rem]" key={room.id}>
                <CodingRoomCard room={room} isCurrent />
              </div>
            ))}
          </div>
        </div>
      )}

      {rooms.user_coding_room.length > 0 && (
        <div className="flex flex-col gap-2 items-center">
          <div className="text-center font-semibold text-lg">Your Rooms</div>
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-8">
            {rooms.user_coding_room.map((room) => (
              <div className="w-[22rem]" key={room.id}>
                <CodingRoomCard room={room} isCurrent />
              </div>
            ))}
          </div>
        </div>
      )}

      {rooms.coding_rooms.length > 0 && (
        <div className="flex flex-col gap-2 items-center">
          <div className="text-center font-semibold text-lg">All Rooms</div>
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-8">
            {rooms.coding_rooms.map((room) => (
              <div className="w-[22rem]" key={room.id}>
                <CodingRoomCard room={room} isCurrent={false} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default CodingRoomsGrid
